// Takes the STEPS array and reduces it into the object format the Formik expects for initialValues, validationSchema, touched, etc.

// Example 1: Grab the initial values for each form field.
// reduceFormElementsToKeyOrValue({
//   items: [
//     {
//       path: 'step-1',
//       formElements: [
//         { name: 'input1', initialValue: 'one' },
//         { name: 'input2', initialValue: 'two' },
//       ],
//     },
//     {
//       path: 'step-2',
//       formElements: [{ name: 'input3', initialValue: 'three' }],
//     },
//   ],
//   key: 'initialValue',
// })
// Returns --> {input1: 'one', input2: 'two', input3: 'three'}

// Example 2: Set each form field to a certain value, i.e., if you want to set them all to touched === true
// reduceFormElementsToKeyOrValue({
//   items: [
//     {
//       path: 'step-1',
//       formElements: [
//         { name: 'input1', initialValue: 'one' },
//         { name: 'input2', initialValue: 'two' },
//       ],
//     },
//     {
//       path: 'step-2',
//       formElements: [{ name: 'input3', initialValue: 'three' }],
//     },
//   ],
//   value: true,
// })
// Returns --> {input1: true, input2: true, input3: true}

export const reduceFormElementsToKeyOrValue = ({ items, key, value, shouldHandleAddress }) =>
  items.reduce(
    (values, { formElements, name, ...rest }) => ({
      ...values,
      ...(!!formElements &&
        reduceFormElementsToKeyOrValue({ items: formElements, key, value, shouldHandleAddress })),
      ...(!!name && { [name]: value ?? rest[key] }),
      ...(!!shouldHandleAddress &&
        !!name?.toLowerCase().includes('address') && {
          [name]: {
            street1: value ?? rest[key],
            street2: value ?? rest[key],
            city: value ?? rest[key],
            state: value ?? rest[key],
            zip: value ?? rest[key],
          },
        }),
    }),
    {}
  );

export const sanitizePhoneNumber = (phoneNumber = '') => {
  const is12Digits = phoneNumber?.length === 12;
  const hasPlusOne = phoneNumber.substring(0, 2) === '+1';
  if (is12Digits && hasPlusOne) return phoneNumber.substring(2);
  return phoneNumber;
};
